<!--
    描述：系统版本
    时间：2020-05-13
    Created by zwh
-->
<template>
    <div class="w-page-main">
        <!-- 顶部搜索栏 -->
        <div class="w-page-header">
            <search-area ref="searchContent" v-model="searchForm.title" placeholderName="标题"
                                        @on-search="onSearch" @on-refresh="onRefresh" @on-reset="onReset">
                <el-form slot="searchform" :model="searchForm" label-width="90px">
                    <el-form-item label="版本号">
                        <el-input placeholder="请输入" v-model="searchForm.versionNum"></el-input>
                    </el-form-item>
                </el-form>
            </search-area>
            <div class="btnGroups ml10">
                <el-button type="primary" size="small" @click="addClick('addVersion')" v-if="roleBtns.includes('version_add')">新增版本</el-button>
            </div>
        </div>

        <!-- 下方内容 -->
        <div class="w-page-container">
            <systemVersionList ref="listTable"></systemVersionList>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import searchArea from '../../../components/searchArea/searchArea'
    import systemVersionList from './components/system_version_list'
    export default {
        components: {systemVersionList},
        props : {},
        data() {
            return {
                searchForm : {
                    title : '',
                    versionNum : '',
                },
            }
        },
        computed: {
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        mounted() {},
        watch: {},
        created() {},
        methods: {
            addClick(type){
                this.$refs.listTable.doClick(null, 'add')
            },
            // 确认搜索
            onSearch() {
                this.$refs.listTable.searchPageList(this.searchForm);
            },

            // 点击刷新
            onRefresh() {
                this.onReset();
                this.onSearch()
            },

            // 点击重置
            onReset() {
                this.$refs.searchContent.title = ''
                this.searchForm.title = ''
                this.searchForm.versionNum = ''
            }
        }
    }
</script>

<style scoped>

</style>